import { Subscription } from "../../models/subscription";
import { useTranslation } from "react-i18next";

export function SubscriptionCell({
  subscription,
}: {
  subscription: Subscription;
}) {
  const { t } = useTranslation();
  return (
    <>
      <thead>
        <tr>
          <th colSpan={2}>
            {t(`userdetail_${subscription.type.toLowerCase()}_subtitle`)}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th>{t("userdetail_common_existence")}</th>
          <td>{subscription.isValid() ? "Y" : "N"}</td>
        </tr>
      </tbody>
    </>
  );
}
